"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HopperCLColumnPropsFullScreen = exports.HopperCLColumnProps = void 0;
const constants_1 = require("utils/constants");
const HopperCLColumnProps = [
    {
        show: true,
        field: 'checkpoint_name',
        title: 'Line',
        width: '220',
        filter: 'text',
        editable: false
    },
    {
        show: true,
        field: 'brand1_name',
        title: 'Coal Brand 1',
        width: '220',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand2_name',
        title: 'Coal Brand 2',
        width: '220',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand3_name',
        title: 'Coal Brand 3',
        width: '220',
        filter: 'text'
    },
    {
        show: true,
        field: 'dumping_type',
        title: 'Dumping Hopper',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220',
        filter: 'date',
        editable: false,
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180',
        filter: 'text',
        editable: false
    },
];
exports.HopperCLColumnProps = HopperCLColumnProps;
const HopperCLColumnPropsFullScreen = [
    {
        show: true,
        field: 'checkpoint_name',
        title: 'Line',
        width: 'auto',
        filter: 'text',
        editable: false
    },
    {
        show: true,
        field: 'brand1_name',
        title: 'Coal Brand 1',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand2_name',
        title: 'Coal Brand 2',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand3_name',
        title: 'Coal Brand 3',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'dumping_type',
        title: 'Dumping Hopper',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220',
        filter: 'date',
        editable: false,
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180',
        filter: 'text',
        editable: false
    },
];
exports.HopperCLColumnPropsFullScreen = HopperCLColumnPropsFullScreen;
